module.exports = __webpack_public_path__ + "img/3min_scan.f94e5273.png";